import styled from 'styled-components';
import { withTheme } from '../../ThemeProvider'; // TODO Sudhir: Add documentation and test cases.

var FormFieldHint = withTheme(styled.div.withConfig({
  displayName: "FormFieldHint",
  componentId: "sc-q0mtuc-0"
})(function (p) {
  return {
    marginTop: p.coreTheme.space_2
  };
}));
export default FormFieldHint;